import axios from 'axios';

export const requestCommand = async (payload) => axios.post('/api/mews-keycutter', payload);
